/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import { Loading } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styles from '../../styles.css';
import useTemplate from '../../../../../hooks/useTemplate';
import SourcesContainer from '../../shared/SourcesContainer';
import SourceItem from '../../shared/SourceItem';

function BibframeTemplates({ setSourceUrl }) {
  const { templates, defaultTemplate, isLoading } = useTemplate();
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const intl = useIntl();

  useEffect(() => {
    if (!isLoading && defaultTemplate) {
      setSelectedTemplate(defaultTemplate);
    }
  }, [defaultTemplate, isLoading]);

  useEffect(() => {
    setSourceUrl(`/inventory/instance-wizard/create/${selectedTemplate?.id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate?.id]);

  const renderTemplates = () => {
    if (isLoading) {
      return <Loading size="large" />;
    }

    if (!isLoading && !templates) {
      return (
        <FormattedMessage
          id="ui-plugin-inventory-templates.query.fetch.noData"
          defaultMessage="No data found!"
        />
      );
    }

    return (
      <div className={styles.templates}>
        {templates
          .sort((a, b) => b.isDefault - a.isDefault)
          .map((template, index) => {
            const localizedName = template?.name?.find(
              (field) => field?.locale === intl.locale,
            )?.value;

            return (
              <SourceItem
                key={`bib-template-${template?.id}`}
                index={index}
                selectedTemplateId={selectedTemplate?.id}
                setSelectedTemplate={setSelectedTemplate}
                sourceLabel={localizedName}
                template={template}
              />
            );
          })}
      </div>
    );
  };

  return (
    <SourcesContainer
      selectedTemplate={selectedTemplate}
      templates={renderTemplates()}
      isLocalizedDesc
    />
  );
}

BibframeTemplates.propTypes = {
  setSourceUrl: PropTypes.string,
};

export default BibframeTemplates;
